import React from 'react';
const ProgressContainer = ({ deleteFile, filename, onUploadProgress, successfullUploaded, uploading, uploadProgress }) => {
    const error_text = 'Unsupported file. File must be of type PDF and 5MB or smaller.';
    const isError = uploadProgress.state === 'error';
    const isDone = uploadProgress.state === 'done';
    return (React.createElement("div", { style: {
            display: "flex",
            alignItems: "center"
        } },
        React.createElement("img", { alt: "done", src: "/baseline-check_circle_outline-24px.svg", style: {
                opacity: isDone ? 0.5 : 0,
                display: isDone ? 'block' : 'none',
                height: "1.1rem",
                paddingRight: "0.5rem"
            } }),
        React.createElement("img", { onClick: e => deleteFile(filename), alt: "delete", src: "/delete-icon.png", style: {
                opacity: ['done', 'error'].includes(uploadProgress.state) ? 1 : 0,
                height: "1rem",
                cursor: "pointer"
            } }),
        React.createElement(Progress, { progress: uploadProgress.percentage, state: uploadProgress.state }),
        React.createElement("div", { className: "tooltip", style: {
                opacity: isError ? 1 : 0,
                display: isError ? 'flex' : 'none',
                alignItems: "center",
            } },
            React.createElement("img", { className: "WarningIcon", style: {
                    display: isError ? 'block' : 'none',
                    height: "1.4rem",
                    margin: "0rem 0.3rem 0rem 1rem"
                }, src: "/yellow-warning-sign.png", alt: "warning!" }),
            React.createElement("span", { className: "tooltiptext" }, error_text))));
};
const Progress = ({ progress, state }) => {
    let cssName = 'Progress';
    if (state === 'error') {
        cssName = 'Progress-failed';
    }
    return (React.createElement("div", { className: "ProgressBar" },
        React.createElement("div", { className: cssName, style: { width: progress + '%' } })));
};
export default ProgressContainer;
